import React from 'react';
import { MapPin, Zap, TrendingDown, Battery, Navigation, Euro, Wifi, Car } from 'lucide-react';
import { stats } from '../data/mock';

export const HeroSection = () => {
  const scrollToDownload = () => {
    const element = document.querySelector('#download');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToHowItWorks = () => {
    const element = document.querySelector('#how-it-works');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
      <section className="hero-section relative overflow-hidden">
        {/* Floating decorative elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {/* Floating icons */}
          <div className="absolute top-32 left-[10%] w-14 h-14 rounded-2xl bg-white/60 backdrop-blur-sm shadow-lg flex items-center justify-center animate-float-slow">
            <Battery size={24} className="text-[#0d7916]" />
          </div>
          <div className="absolute top-48 right-[12%] w-12 h-12 rounded-xl bg-white/50 backdrop-blur-sm shadow-lg flex items-center justify-center animate-float-medium">
            <Euro size={20} className="text-[#0d7916]" />
          </div>
          <div className="absolute bottom-[35%] left-[8%] w-10 h-10 rounded-lg bg-white/40 backdrop-blur-sm shadow-md flex items-center justify-center animate-float-fast">
            <Wifi size={18} className="text-[#0d7916]" />
          </div>
          <div className="absolute top-[40%] right-[8%] w-16 h-16 rounded-2xl bg-white/50 backdrop-blur-sm shadow-lg flex items-center justify-center animate-float-slow">
            <Car size={28} className="text-[#0d7916]" />
          </div>
          <div className="absolute bottom-[25%] right-[15%] w-11 h-11 rounded-xl bg-white/40 backdrop-blur-sm shadow-md flex items-center justify-center animate-float-medium">
            <Navigation size={20} className="text-[#0d7916]" />
          </div>

          {/* Decorative circles */}
          <div className="absolute top-20 right-[30%] w-64 h-64 rounded-full bg-[#8FEC78]/20 blur-3xl" />
          <div className="absolute bottom-32 left-[20%] w-48 h-48 rounded-full bg-[#81DD67]/15 blur-2xl" />
          <div className="absolute top-[50%] left-[5%] w-32 h-32 rounded-full bg-yellow-300/20 blur-2xl" />
        </div>

        <div className="hero-content relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center max-w-7xl mx-auto px-4">
            {/* Left Column - Text Content */}
            <div className="text-center lg:text-left">
              {/* Badge */}
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/80 border border-[rgba(0,0,0,0.1)] mb-8 backdrop-blur-sm shadow-sm">
                <Zap size={16} className="text-[rgb(13,121,22)]" />
                <span className="text-sm font-medium text-[rgb(131,146,140)]">Il motore di ricerca delle colonnine di ricarica</span>
              </div>

              {/* Main Heading */}
              <h1 className="hero-title">
                Ricarica Smart,<br />
                <span className="text-[rgb(13,121,22)]">Risparmia di Più</span>
              </h1>

              {/* Subtitle */}
              <p className="hero-subtitle">
                EZVI' confronta i prezzi di tutti gli operatori per ogni colonnina in Italia.<br className="hidden md:block" />
                Trova sempre la tariffa migliore, senza vincoli.
              </p>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row items-center lg:items-start justify-center lg:justify-start gap-4 mb-12">
                <button onClick={scrollToDownload} className="btn-primary">
                  <span>Scarica Gratis</span>
                </button>
                <button onClick={scrollToHowItWorks} className="btn-secondary">
                  <span>Scopri Come Funziona</span>
                </button>
              </div>

              {/* Value Props Icons */}
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-12">
                <div className="flex items-center gap-2 bg-white/50 backdrop-blur-sm rounded-full px-4 py-2 shadow-sm">
                  <div className="w-8 h-8 rounded-full bg-[rgba(148,242,127,0.2)] flex items-center justify-center">
                    <MapPin size={16} className="text-[rgb(13,121,22)]" />
                  </div>
                  <span className="text-sm font-medium text-[rgb(131,146,140)]">50.000+ colonnine</span>
                </div>
                <div className="flex items-center gap-2 bg-white/50 backdrop-blur-sm rounded-full px-4 py-2 shadow-sm">
                  <div className="w-8 h-8 rounded-full bg-[rgba(148,242,127,0.2)] flex items-center justify-center">
                    <TrendingDown size={16} className="text-[rgb(13,121,22)]" />
                  </div>
                  <span className="text-sm font-medium text-[rgb(131,146,140)]">Risparmio garantito</span>
                </div>
                <div className="flex items-center gap-2 bg-white/50 backdrop-blur-sm rounded-full px-4 py-2 shadow-sm">
                  <div className="w-8 h-8 rounded-full bg-[rgba(148,242,127,0.2)] flex items-center justify-center">
                    <Zap size={16} className="text-[rgb(13,121,22)]" />
                  </div>
                  <span className="text-sm font-medium text-[rgb(131,146,140)]">100% indipendente</span>
                </div>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-2 gap-6 max-w-md mx-auto lg:mx-0">
                {stats.map((stat) => (
                    <div key={stat.id} className="text-center lg:text-left bg-white/40 backdrop-blur-sm rounded-2xl p-4 shadow-sm">
                      <div className="text-2xl md:text-3xl font-bold text-[rgb(0,55,32)] mb-1">{stat.value}</div>
                      <div className="text-sm text-[rgb(131,146,140)]">{stat.label}</div>
                    </div>
                ))}
              </div>
            </div>

            {/* Right Column - iPhone Mockup */}
            <div className="relative flex items-center justify-center lg:justify-end">
              {/* Glow effect behind phone */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-64 h-64 md:w-80 md:h-80 rounded-full bg-[#0d7916]/20 blur-3xl animate-pulse-slow" />
              </div>

              {/* iPhone Mockup */}
              <div className="relative z-10 transform hover:scale-105 transition-transform duration-500">
                {/* iPhone Frame */}
                <div className="relative w-[280px] h-[570px] md:w-[320px] md:h-[650px] bg-[#1d1d1f] rounded-[3rem] p-3 shadow-2xl">
                  {/* Inner bezel */}
                  <div className="relative w-full h-full bg-black rounded-[2.5rem] overflow-hidden">
                    {/* Notch */}
                    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[120px] h-[30px] bg-black rounded-b-3xl z-20" />

                    {/* Screen content */}
                    <div className="relative w-full h-full">
                      <img
                          src="/images/map_station_sshot.jpeg"
                          alt="EZVI App - Confronta prezzi colonnine di ricarica"
                          className="w-full h-full object-cover"
                          className="w-full h-full object-cover"
                      />
                    </div>

                    {/* Status bar overlay - subtle gradient to blend notch */}
                    <div className="absolute top-0 left-0 right-0 h-12 bg-gradient-to-b from-black/20 to-transparent pointer-events-none z-10" />
                  </div>

                  {/* Side buttons */}
                  <div className="absolute -left-[3px] top-[120px] w-[3px] h-[30px] bg-[#1d1d1f] rounded-l-sm" />
                  <div className="absolute -left-[3px] top-[170px] w-[3px] h-[50px] bg-[#1d1d1f] rounded-l-sm" />
                  <div className="absolute -left-[3px] top-[230px] w-[3px] h-[50px] bg-[#1d1d1f] rounded-l-sm" />
                  <div className="absolute -right-[3px] top-[180px] w-[3px] h-[70px] bg-[#1d1d1f] rounded-r-sm" />
                </div>

                {/* Floating price comparison badges */}
                <div className="absolute -left-4 top-[45%] bg-white rounded-2xl px-4 py-3 shadow-xl animate-float-slow hidden md:block">
                  <div className="text-xs font-semibold text-[#0d7916] mb-1">Risparmio</div>
                  <div className="text-lg font-bold text-[rgb(0,55,32)]">€0.14/kWh</div>
                </div>

                <div className="absolute -right-4 top-[30%] bg-white rounded-2xl px-4 py-3 shadow-xl animate-float-medium hidden md:block">
                  <div className="text-xs font-semibold text-[#0d7916] mb-1">Tariffa Migliore</div>
                  <div className="text-lg font-bold text-[rgb(0,55,32)]">€0.65/kWh</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden lg:block">
          <div className="w-6 h-10 rounded-full border-2 border-[rgb(175,183,180)] flex items-start justify-center p-2">
            <div className="w-1.5 h-3 rounded-full bg-[rgb(175,183,180)]" />
          </div>
        </div>

        <style jsx>{`
        @keyframes float-slow {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @keyframes float-medium {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-15px); }
        }
        @keyframes float-fast {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        @keyframes pulse-slow {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 0.5; }
        }
        .animate-float-slow {
          animation: float-slow 6s ease-in-out infinite;
        }
        .animate-float-medium {
          animation: float-medium 5s ease-in-out infinite;
        }
        .animate-float-fast {
          animation: float-fast 4s ease-in-out infinite;
        }
        .animate-pulse-slow {
          animation: pulse-slow 4s ease-in-out infinite;
        }
      `}</style>
      </section>
  );
};

export default HeroSection;
